import { Component, OnInit } from '@angular/core';
import { Consts } from '../app.consts';
import { MetaTag, MetaTagService } from '../core/services/mata-tag.service';
import { CurrentPage, PageService } from '../core/services/page.service';
import { OwlOptions } from 'ngx-owl-carousel-o';


@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

	private updateMeta() {
		let metaTag: MetaTag = {
			title: Consts.AppTitle,
			description: Consts.AppDescription,
			route: '',
			image: 'assets/images/cover-image.jpg',
			imageAlt: 'Website logo'
		}
		this.metaTagService.metaTags(metaTag);
	}

	public customOptions: OwlOptions = {
		loop: true,
		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		dots: true,
		navSpeed: 700,
		margin: 20,
		responsive: {
			0: {
				items: 1
			},
			450: {
				items: 1
			}
		},
		nav: false,
		autoplay: false,
		autoWidth: false,
		autoHeight: false
	};


	constructor(
		private metaTagService: MetaTagService,
		private pageService: PageService) {
		this.pageService.setPage(CurrentPage.Home);
	}

	ngOnInit(): void {
			this.updateMeta();
		setTimeout(() => {
		}, 100)
	}

}
